// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"323":"1cf8fe840d1ba3e5","571":"ff86a827db5579b3","2564":"e527e5ae976e5785","4653":"5589eddb8e686acb","9888":"4d6b1e618289a039","9998":"7bc9e8fd5a904f65"}[chunkId] + ".css";
};